<template>
  <div class="mt-2 d-flex align-items-center">
    <label class="font-weight-bold text-muted font-size-small mb-0 pb-0">Active Integration Setting:</label>
    <div class="d-flex align-items-center pl-2">
      <strong>{{ phaseIntegrationSaveStateName }}</strong>
      <AppButton
        v-if="isUsingRevampedMergeSettings && phaseIntegrationSaveStateName !== '-'"
        inlineStyle
        class="pl-0 pr-0"
        aria-label="Open Integration Settings Details"
        title="Open Integration Settings Details"
        :to="{
          name: 'adminMergeSettingsSavedState',
          params: {
            school,
            savedStateId: phase.integrationSaveStateId
          }
        }"
      >
        <AppIcon name="open_in_new" size="14" class="ml-1" />
      </AppButton>
    </div>

  </div>
</template>

<script>
import store from '@/store'
import { computed, ref } from '@vue/composition-api'
import { getIntegrationSaveStates } from '@/api'
import { ADMIN_MERGE_SETTINGS_REVAMP } from '@shared/constants/featureFlags'
import useFeatureFlags from '@/components/composables/useFeatureFlags'

export default {
  props: {
    phaseId: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const { isUsingRevampedMergeSettings } = useFeatureFlags({
      isUsingRevampedMergeSettings: ADMIN_MERGE_SETTINGS_REVAMP,
    })

    const school = store.getters.school
    const phase = computed(() => store.getters['phases/getById'](props.phaseId))
    const integrationSaveStateId = computed(() => phase.value?.integrationSaveStateId)

    const integrationSaveStates = ref([])
    // TODO: Replace with useIntegrationSavedStates once HD-3253 is merged
    async function fetchIntegrationSaveStates () {
      integrationSaveStates.value = Object.values(await getIntegrationSaveStates({ school }) || {})
    }
    fetchIntegrationSaveStates()
    const phaseIntegrationSaveStateName = computed(() => {
      if (!integrationSaveStateId.value) return '-'
      const matchingSavedState = integrationSaveStates.value.find(iss => iss._id === integrationSaveStateId.value)
      return matchingSavedState?.name || 'Unnamed'
    })

    return {
      school,
      phase,
      phaseIntegrationSaveStateName,
      isUsingRevampedMergeSettings,
    }
  },
}
</script>
